import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { ThreeSectionsLayout1, ThreeSectionsLayout1Component } from 'app/views/presentations/layouts/layouts/threeSectionsLayout1/threeSectionsLayout1.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(ThreeSectionsLayout1)
    ],
    declarations: [
        ThreeSectionsLayout1Component
    ],
    entryComponents: [
        ThreeSectionsLayout1Component
    ]
})
export class ThreeSectionsLayout1Module { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout1/threeSectionsLayout1.module.ts